import Sad from '../../img/sad.svg'
import Happy from '../../img/happy.svg'

const UnidataStatus = (generalStatus, unidataStatus) => {

    let name = (generalStatus.substring(0, 4) === 'city') ? 'comune' : 'civico';

    return(
        unidataStatus ? 
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
            <img src={Happy} alt='face' className="icon"/>
            <p style={{fontSize: '1.9rem', textAlign: 'center'}}>{name.charAt(0).toUpperCase() + String(name).slice(1)} <span style={{color:'#2ecc71', fontWeight: 'bold'}}>connesso</span> alla rete Unidata.</p>
        </div>
        :
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
            <img src={Sad} alt='face' className="icon"/>
            <p style={{fontSize: '1.8rem', textAlign: 'center'}}>Oh no...{name} <span style={{color:'#D2042D', fontWeight: 'bold'}}>non connesso</span><span style={{color:'#FF0F64'}}></span> alla rete Unidata.</p>
        </div>

    )
}

export default UnidataStatus;